export default {
      id: "pin-usage",
      viewBox: "0 0 11 14",
      url: __webpack_public_path__ + "img/icons.159f8dce.svg#pin",
      toString: function () {
        return this.url;
      }
    }